import { assertCanHandle } from '@lucidlink/tscore';
import { Logging } from '#common/logging';
import { canHandleAllErrors } from '#common/util';
export const createTelemetryClient = (params) => {
    return new TelemetryClientImpl(params.nodeId, params.filespaceId, params.username, params.metaStore, params.keyValueHelpers);
};
class TelemetryClientImpl {
    nodeId;
    filespaceId;
    username;
    metaStore;
    keyValueHelpers;
    log = Logging.getLogger('TelemetryClient');
    constructor(nodeId, filespaceId, username, metaStore, keyValueHelpers) {
        this.nodeId = nodeId;
        this.filespaceId = filespaceId;
        this.username = username;
        this.metaStore = metaStore;
        this.keyValueHelpers = keyValueHelpers;
    }
    sendMetrics(telemetryName, tuple) {
        const record = this.keyValueHelpers.makeTelemetryRecord(this.nodeId, telemetryName, this.username, tuple);
        this.doSendMetrics(telemetryName, record).catch(() => { });
    }
    sendMetricsRaw(telemetryName, value) {
        const record = this.keyValueHelpers.makeRawTelemetryRecord(this.nodeId, telemetryName, value);
        this.doSendMetrics(telemetryName, record).catch(() => { });
    }
    async doSendMetrics(name, record) {
        try {
            this.log.trace(`sendTelemetry, "${name}"`);
            const records = new Array();
            records.push(record);
            await this.metaStore.commitKeyValuePairs(records, true);
        }
        catch (err) {
            assertCanHandle(err, canHandleAllErrors);
            this.log.warn({ 'filespace.fsId': this.filespaceId, errorMessage: err }, `Failed to send telemetry for ${name}.`);
        }
    }
}
